export const parsePrice = (value: string | null | undefined): number => {
  if (!value) return 0
  const normalized = value.replace(/,/g, '')
  const parsed = Number.parseInt(normalized, 10)
  return Number.isFinite(parsed) ? parsed : 0
}
